import React from "react";
import ModelEmpty from "../../../components/commonModal/ModelEmpty";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { reCallById, setHold } from "../../../store/pos/posSlice";

const HoldedData: React.FC = () => {
  const dispatch = useDispatch();

  const { holed, openHold } = useSelector((state: RootState) => state.pos);

  const time = (i: any) => {
    const dateObj = new Date(i);
    if (isNaN(dateObj.getTime())) {
      return "--:--";
    }
    const timeOnly = dateObj.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return timeOnly;
  };

  const date = (i: any) => {
    const dateObj = new Date(i);
    if (isNaN(dateObj.getTime())) {
      return "N/A";
    }
    const timeOnly = dateObj.toLocaleDateString();
    return timeOnly;
  };

  return (
    <ModelEmpty
      setopen={(e) => dispatch(setHold(e))}
      open={openHold}
      className="holdedData"
    >
      <div className="hold_container">
        <div className="hold_header">
          <h2>Held Orders</h2>
          <p className="hold_count">
            {holed?.length || 0} Order{holed?.length !== 1 ? "s" : ""} on Hold
          </p>
        </div>
        <div className="hold_list">
          {holed && holed.length > 0 ? (
            holed.map((item: any, i: number) => (
              <button
                className="hold_item"
                onClick={() => dispatch(reCallById(item?.id))}
                key={i}
              >
                <div className="hold_item_header">
                  <span className="hold_item_number">Order #{i + 1}</span>
                  <span className="hold_item_date">{date(item?.id)}</span>
                </div>
                <div className="hold_item_footer">
                  <span className="hold_item_time">{time(item?.id)}</span>
                  <span className="hold_item_action">Tap to Resume</span>
                </div>
              </button>
            ))
          ) : (
            <div className="hold_empty">
              <p>No held orders</p>
            </div>
          )}
        </div>
      </div>
    </ModelEmpty>
  );
};

export default HoldedData;
